import { put, fork, all, select, takeEvery, call } from 'redux-saga/effects';
import { get } from 'lodash';
import {
  fetchClusters,
  CREATE_CLUSTER_SUCCESS,
  DELETE_CLUSTER_SUCCESS
} from 'modules/aiWare';
import { selectUser } from 'modules/user';

function* loadData() {
  const userInfo = yield select(selectUser);
  const organizationId = get(userInfo, 'organization.organizationId', '');

  yield put(fetchClusters(organizationId));
}

function* onCreateClusterSuccess() {
  yield call(loadData);
}

function* watchCreateClusterSuccess() {
  yield takeEvery(CREATE_CLUSTER_SUCCESS, onCreateClusterSuccess);
}

function* onDeleteClusterSuccess() {
  yield call(loadData);
}

function* watchDeleteClusterSuccess() {
  yield takeEvery(DELETE_CLUSTER_SUCCESS, onDeleteClusterSuccess);
}

export default function* root() {
  yield all([
    fork(loadData),
    fork(watchCreateClusterSuccess),
    fork(watchDeleteClusterSuccess)
  ]);
}



// WEBPACK FOOTER //
// ./src/client/plugins/aiware/modules/saga.js